export default '/build/fc4b88a8.svg'